import { createActionConst } from '../../../utils/action.utils';

const ITEM_NAMESPACE = 'ITEM';

export const STORE_ITEM = createActionConst(ITEM_NAMESPACE, 'STORE_ITEM');
export const CLEAR_ITEM = createActionConst(ITEM_NAMESPACE, 'CLEAR_ITEM');
